<template>
  <div class="main">
    <div class="main_bg">
      <div>
        <contentMenu :index="2"></contentMenu>
      </div>
      <div class="banner">
        <contentVideo :url="videourl" :img="videoimgMobile"></contentVideo>
      </div>
      <div class="main2-content">
        <div class="layout-flex">
          <div class="item-title">
            <div class="item-line">
              <img class="item-iconTit" src="../../assets/meb/imgsMobile/mIconTit@2x.png" />
              揭秘MEB工厂
            </div>
          </div>
          <div class="item-img-content">
            <img class="item-img" :src="list[0].imageurl" />
          </div>
          <div class="item-dec" v-html="list[0].dec"></div>
          <div class="item-img-content">
            <img class="item-img" :src="list[1].imageurl" />
          </div>
          <div class="item-dec" v-html="list[1].dec"></div>
          <div class="item-img-content">
            <img class="item-img" :src="list[2].imageurl" />
          </div>
          <div class="item-dec" v-html="list[2].dec"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config";
import contentVideo from "./contentVideoMobile.vue";
import contentMenu from "./contentMenuMobile.vue";
import contentLeft from "./contentLeftMobile.vue";
import contentRight from "./contentRightMobile.vue";
export default {
  components: {
    contentVideo,
    contentMenu,
    contentLeft,
    contentRight
  },
  data() {
    return {
      videourl: csvw_url + "/u/cms/www/202010/261834124oGl.mp4",
      videoimgMobile: require("../../assets/meb/imgsMobile/gcgs/mGcBanner@2x.png"),
      imageurlMobile: "",
      list: [
        {
          imageurl: require("../../assets/meb/imgsMobile/gcgs/mGcTu1@2x.png"),
          dec:
            "上汽大众新能源汽车工厂位于上海安亭，是大众汽车集团全球首个专为MEB平台车型生产而全新建造的工厂，也是上汽大众面向未来、实现2025战略的重要里程碑。"
        },
        {
          imageurl: require("../../assets/meb/imgsMobile/gcgs/mGcTu2@2x.png"),
          dec:
            "新工厂项目总投入约170亿元，规划年产能30万辆，计划于2020年10月正式投产，是目前国内生产规模最大、效率最高的纯电动汽车工厂。"
        },
        {
          imageurl: require("../../assets/meb/imgsMobile/gcgs/mGcTu3@2x.png"),
          dec:
            "未来，新能源汽车工厂将基于MEB平台建构起适合中国消费者的纯电动车家族，满足不同消费者的需求。"
        }
      ]
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 375px;
  margin: 0px auto;
  font-size: 14px;
}

.main_bg {
  width: 100%;
  min-width: 375px;
  background: #ffffff;
}

.main2-content {
  width: calc(100% - 0px);
  margin: 0px 0px;
}
.divHeight {
  height: 23px;
}

.main2-content {
  .layout-flex {
    width: 375px;
    padding: 20px 10px 20px 10px;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    .item-line {
      float: left;
      border-bottom: 3px solid rgba(40, 132, 244, 0.2);
    }
    .item-iconTit {
      width: 16px;
      height: 16px;
      padding-right: 5px;
    }
    .item-title {
      height: 30px;
      font-size: 16px;
      font-weight: 400;
      color: #0077c8;
    }
    .item-dec {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
      margin-top: 15px;
    }
    .item-img-content {
      width: 355px;
      height: 195px;
      margin-top: 15px;
    }
    .item-img {
      width: 355px;
      height: 195px;
    }
  }
}
</style>
